<template>
  <WithCustomSidebar :config="navigation">
    <slot />
  </WithCustomSidebar>
</template>

<script>
import WithCustomSidebar from '@@/layout/Sidebar/WithCustomSidebar';
import ChecklistIcon from '@/assets/icons/checklist.svg';
import EditIcon from '@/assets/icons/edit.svg';
import MoneyTransferIcon from '@/assets/icons/money-transfer.svg';
import StatsIcon from '@/assets/icons/stats.svg';
import useAuth from '@/auth';

export default {
  name: 'WithCampaignInternalNav',
  components: {
    WithCustomSidebar,
  },
  computed: {
    navigation() {
      const { user } = useAuth();
      return {
        key: 'search-ads-sidebar',
        backButton: {
          route: user.isAdvertisementAdmin
            ? 'advertisement-manage-campaigns'
            : 'search-ads-campaigns-list',
          title: 'ADVERTISEMENT.TITLE',
        },
        items: [
          {
            route: 'search-ads-campaign-info',
            title: 'ADVERTISEMENT.CAMPAIGN_VIEW.INFO.TITLE',
            icon: EditIcon,
          },
          {
            title: 'ADVERTISEMENT.KEYWORDS.TITLE',
            route: 'search-ads-campaign-bids',
            icon: ChecklistIcon,
            children: [
              {
                route: 'search-ads-campaign-bids',
                title: 'ADVERTISEMENT.CAMPAIGN_DETAILS.BIDS_LIST.TITLE',
              },
              {
                route: 'search-ads-negative-keywords',
                title: 'ADVERTISEMENT.NEGATIVE_KEYWORDS.TITLE',
              },
              {
                route: 'search-ads-search-terms',
                title: 'ADVERTISEMENT.SEARCH_TERMS.TITLE',
              },
            ],
          },
          {
            title: 'ADVERTISEMENT.CAMPAIGN_VIEW.STATS.TITLE',
            route: 'search-ads-campaign-stats-overall',
            icon: StatsIcon,
            children: [
              {
                title: 'ADVERTISEMENT.CAMPAIGN_VIEW.STATS.OVERALL.TITLE',
                route: 'search-ads-campaign-stats-overall',
              },
              {
                title: 'ADVERTISEMENT.CAMPAIGN_VIEW.STATS.BUILDER.TITLE',
                route: 'search-ads-campaign-stats-builder',
              },
            ],
          },
          {
            route: 'search-ads-campaign-finance',
            title: 'ADVERTISEMENT.CAMPAIGN_FINANCE.TITLE',
            icon: MoneyTransferIcon,
          },
        ],
      };
    },
  },
};
</script>
